export enum FeedbackComponentTypes {
	STARS = 'stars',
	THUMBS = 'thumbs',
}

export enum FeedbackTypes {
	SESSION = 'session',
	ARTICLE = 'article',
}
